var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComboProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD835"
    },
    d: "M98.872,280.085c-22.554-5.07-43.721-15.807-61.209-31.054c-3.415-2.977-5.374-7.285-5.374-11.815 V118.143c0-8.656,7.018-15.673,15.673-15.673h54.346c8.656,0,15.673,7.018,15.673,15.673v146.65 C117.983,274.825,108.664,282.288,98.872,280.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF176"
    },
    d: "M99.087,280.129c-7.167-1.597-12.265-7.956-12.265-15.299V118.143 c0-8.656,7.018-15.673,15.673-15.673h54.346c8.656,0,15.673,7.018,15.673,15.673V264.83c0,7.342-5.098,13.702-12.266,15.299 C140.189,284.597,119.152,284.598,99.087,280.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD835"
    },
    d: "M156.841,102.469h-27.173V283.48c10.276,0,20.55-1.117,30.58-3.352 c7.168-1.597,12.266-7.956,12.266-15.299V118.143C172.515,109.487,165.497,102.469,156.841,102.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A825"
    },
    d: "M141.353,264.793V93.333c0-8.656,7.018-15.673,15.673-15.673h54.345 c8.656,0,15.673,7.018,15.673,15.673v143.896c0,4.532-1.961,8.842-5.378,11.819c-17.493,15.238-38.656,25.97-61.203,31.038 C150.648,282.293,141.353,274.802,141.353,264.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E53935"
    },
    d: "M243.661,497.179H15.673C7.018,497.179,0,490.161,0,481.505V193.341 c0-7.417,5.198-13.818,12.456-15.34c7.26-1.517,14.59,2.251,17.569,9.042c37.99,86.568,161.097,86.882,199.287-0.009 c2.983-6.788,10.314-10.557,17.571-9.032c7.256,1.525,12.451,7.924,12.451,15.339v288.164 C259.334,490.162,252.318,497.179,243.661,497.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C62828"
    },
    d: "M246.883,178.002c-7.257-1.525-14.588,2.243-17.571,9.032c-19.083,43.419-59.37,65.062-99.645,65.05 v245.094h113.993c8.656,0,15.673-7.018,15.673-15.673V193.341C259.334,185.927,254.14,179.527,246.883,178.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF176"
    },
    d: "M129.668,416.933c-26.242,0-47.591-21.349-47.591-47.591s21.349-47.592,47.591-47.592 s47.592,21.35,47.592,47.592S155.909,416.933,129.668,416.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD835"
    },
    d: "M177.26,369.342c0-26.242-21.349-47.592-47.591-47.592v95.183 C155.909,416.931,177.26,395.583,177.26,369.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A82A1"
    },
    d: "M374.716,117.403c-8.656,0-15.673-7.018-15.673-15.673V30.494c0-8.656,7.018-15.673,15.673-15.673 h28.085c8.656,0,15.673,7.018,15.673,15.673s-7.018,15.673-15.673,15.673H390.39v55.563 C390.39,110.387,383.372,117.403,374.716,117.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36495E"
    },
    d: "M402.801,14.82h-28.085v102.584c8.656,0,15.673-7.018,15.673-15.673V46.167h12.411 c8.656,0,15.673-7.018,15.673-15.673S411.457,14.82,402.801,14.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64B5F6"
    },
    d: "M447.681,311.684c-16.132-21.548-40.798-33.907-67.674-33.907h-10.584 c-26.876,0-51.541,12.359-67.674,33.907c-8.534,11.405-26.714,6.361-28.142-7.824l-15.41-153.204 c-0.928-9.233,6.33-17.242,15.595-17.242h201.845c9.278,0,16.521,8.024,15.595,17.242l-15.41,153.204 C474.395,318.05,456.225,323.098,447.681,311.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M475.639,133.414H374.716v144.363h5.291c26.876,0,51.541,12.359,67.674,33.907 c8.544,11.413,26.714,6.366,28.142-7.824l15.41-153.204C492.159,141.437,484.916,133.414,475.639,133.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEEEE"
    },
    d: "M496.327,164.761H253.106c-8.656,0-15.673-7.018-15.673-15.673V101.73 c0-8.656,7.018-15.673,15.673-15.673h243.221c8.656,0,15.673,7.018,15.673,15.673v47.357 C512,157.744,504.982,164.761,496.327,164.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBD"
    },
    d: "M496.327,86.056h-121.61v78.704h121.61c8.656,0,15.673-7.018,15.673-15.673V101.73 C512,93.074,504.982,86.056,496.327,86.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57373"
    },
    d: "M450.969,436.564H298.466c-24.738,0-44.864-20.126-44.864-44.864 c0-24.833,20.126-44.958,44.864-44.958h152.503c24.737,0,44.863,20.126,44.863,44.864 C495.83,416.438,475.705,436.564,450.969,436.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E53935"
    },
    d: "M450.969,346.743h-76.252v89.822h76.252c24.737,0,44.863-20.126,44.863-44.958 C495.83,366.867,475.705,346.743,450.969,346.743z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF176"
    },
    d: "M480.157,497.179H269.275c-8.656,0-15.673-7.018-15.673-15.673V420.89 c0-8.656,7.018-15.673,15.673-15.673h210.881c8.656,0,15.673,7.018,15.673,15.673v60.616 C495.83,490.162,488.814,497.179,480.157,497.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF176"
    },
    d: "M480.157,378.091H269.275c-8.656,0-15.673-7.018-15.673-15.673v-0.163 c0-63.865,51.959-115.824,115.823-115.824h10.584c63.864,0,115.823,51.959,115.823,115.824v0.163 C495.83,371.073,488.814,378.091,480.157,378.091z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD835"
    },
    d: "M480.157,405.217H374.716v91.963h105.441c8.656,0,15.673-7.018,15.673-15.673v-60.616 C495.83,412.234,488.814,405.217,480.157,405.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD835"
    },
    d: "M380.008,246.43h-5.291v131.66h105.441c8.656,0,15.673-7.018,15.673-15.673v-0.163 C495.83,298.388,443.873,246.43,380.008,246.43z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboProductIcon);
export default __webpack_public_path__ + "static/media/comboProductIcon.3261f7cc61b6f72b1144173b32e203af.svg";
export { ForwardRef as ReactComponent };